export const setRememberAction = (payload) => {
    return {
        type: "remember",
        payload
    }
};

export const setPassRequestToOtherLandlordsAction = (payload) => {
    return {
        type: "pass_request_to_other_landlords",
        payload
    }
};

export const setPrivacyPolicyAction = (payload) => {
    return {
        type: "privacy_policy",
        payload
    }
};